import { render } from "./ProductModal.vue?vue&type=template&id=ec47b4a4&scoped=true"
import script from "./ProductModal.vue?vue&type=script&lang=js"
export * from "./ProductModal.vue?vue&type=script&lang=js"

import "./ProductModal.vue?vue&type=style&index=0&id=ec47b4a4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec47b4a4"]])

export default __exports__